import { JSX, useMemo } from "react";

import { Grid, Alert } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useLocationsDataQuery } from "src/api/locationQueries.api";
import IntervalTabsWrapper from "src/components/IntervalTabs/IntervalTabsWrapper";
import Footfall from "src/components/RegionDashboard/Footfall/Footfall";
import FootfallPinnedLocations from "src/components/RegionDashboard/FootfallPinnedLocations/FootfallPinnedLocations";
import FootfallLastHourComponent from "src/components/RegionDashboard/LiveSection/FootfallLastHourComponent";
import PinnedComponent from "src/components/RegionDashboard/Pinned/PinnedComponent";
import SectionTitleWrapper from "src/components/SectionWrapper/SectionWrapper";
import ComponentId from "src/constants/componentId.enum";
import LocationType from "src/types/LocationType";

const componentId = ComponentId.IntervalTabsWithDatepicker;

const styles = {
  warning: { xs: 12, md: 4 },
  fullWidth: { xs: 12 },
};

function ShopRegionDashboard(): JSX.Element {
  const { t } = useTranslation();
  const { locationId } = useParams();
  const { data: locations, isLoading } = useLocationsDataQuery();

  const selectedLocation = useMemo(() => locations?.value.find((location) => location.Id === locationId), [locationId, locations]);

  return (
    <>
      {!isLoading && !selectedLocation && (
        <Grid size={styles.warning}>
          <Alert severity='warning'>{t("No selected Location")}</Alert>
        </Grid>
      )}

      {selectedLocation && (
        <>
          <Grid size={styles.fullWidth}>
            <PinnedComponent displayedType={LocationType.Shop} />
          </Grid>
          <IntervalTabsWrapper componentId={componentId} title={"Historic"}>
            <Grid container spacing={2}>
              <Grid size={styles.fullWidth}>
                <Footfall selectedLocation={selectedLocation} displayedType={LocationType.Shop} componentId={componentId} />
              </Grid>

              <Grid size={styles.fullWidth}>
                <FootfallPinnedLocations selectedLocation={selectedLocation} displayedType={LocationType.Shop} componentId={componentId} />
              </Grid>
            </Grid>
          </IntervalTabsWrapper>
          <SectionTitleWrapper title={"Details"}>
            <Grid size={styles.fullWidth}>
              <FootfallLastHourComponent selectedLocation={selectedLocation} displayedType={LocationType.Shop} />
            </Grid>
          </SectionTitleWrapper>
        </>
      )}
    </>
  );
}

export default ShopRegionDashboard;
